<div class="container-fluid registro-notas">

  <div class="rn-header rounded">
    <div class="row align-items-center">
      <div class="col-md-1 text-center"><i class="fa-solid fa-clipboard-list fa-2xl"></i></div>
      <div class="col-md-7">
        <div class="rn-header-title">REGISTRANDO ACTA {{ tipoActaActual || 'ORDINARIA' }}</div>
        <div class="rn-header-sub">{{ header.M05DES }}</div>
      </div>

    </div>
  </div>

  <div class="rn-context">
    <div class="row">
      <div class="col-md-7">
        <div class="rn-context-line"><b>{{ header.M11COD }}</b> {{ header.M11DES }} - Grupo {{ header.M23GRU }}</div>
        <div class="rn-context-line"><b>Periodo:</b> {{ header.M19DES || header.M19COD }}</div>
        <div class="rn-context-line"><b>Profesor:</b> {{ header.PROFESOR_NOM }} <span *ngIf="header.PROFESOR_COD">(#{{ header.PROFESOR_COD }})</span></div>
      </div>
      <div class="col-md-5 rn-reportes">
        <button *ngFor="let r of reportes"
                type="button"
                class="btn btn-link rn-reporte-btn"
                (click)="imprimirReporte(r)">
          <i *ngIf="r.SYS21ICO" class="fa {{ r.SYS21ICO }}"></i>
          {{ r.SYS10DES }}
        </button>
      </div>
    </div>
  </div>

  <div class="rn-toolbar d-flex justify-content-end">
    <div class="rn-buscador">
      <label class="rn-label">Carn&eacute; o nombre:</label>
      <input type="text" class="form-control form-control-sm"
            [(ngModel)]="buscaCarne"
            (keypress)="buscarCarne($event)">
    </div>
  </div>

  <div class="rn-table-wrap" *ngIf="!cargando; else loading">
    <table class="table table-bordered table-sm rn-matriz">
      <thead class="table-light">
        <tr>
          <th class="rn-col-fija">#</th>
          <th class="rn-col-fija">Carnet</th>
          <th class="rn-col-fija">Nombre</th>
          <th class="rn-col-fija">Mat.</th>
          <th *ngFor="let col of columnas" [title]="col.E45DES">{{ col.E45DES }}</th>
          <th class="rn-col-fija">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let est of estudiantes; let i = index"
            [class.rn-fila-activa]="filaActiva === i">
          <td>{{ i + 1 }}</td>
          <td>{{ est.M12CAR }}</td>
          <td>{{ est.M12NOM }}</td>
          <td><span class="badge bg-secondary">{{ est.ESTMAT }}</span></td>

          <td *ngFor="let col of columnas" class="rn-celda" [class.rn-celda-readonly]="col.EDITABLE !== 'S'">
            <input *ngIf="col.EDITABLE === 'S'"
                   type="text"
                   class="form-control form-control-sm rn-input-nota"
                   [value]="notaDe(est, col)"
                   (focus)="marcarFila(i); guardarValorAnterior(est, col, $any($event.target))"
                   (blur)="grabarNota(est, col, $any($event.target))">
            <span *ngIf="col.EDITABLE !== 'S'" class="rn-promedio">{{ notaDe(est, col) }}</span>
          </td>

          <td>
            <select class="form-select form-select-sm"
                    [(ngModel)]="est.M38COD"
                    (focus)="guardarEstadoAnterior(est, $any($event.target))"
                    (change)="cambiarEstado(est, $any($event.target))">
              <option value="">-- Seleccione --</option>
              <option *ngFor="let e of estadosDe(est)" [value]="e.M38COD">{{ e.M38DES }}</option>
            </select>
          </td>
        </tr>
        <tr *ngIf="estudiantes.length === 0">
          <td [attr.colspan]="columnas.length + 5" class="text-center">
            No se encuentran estudiantes registrados
          </td>
        </tr>
      </tbody>
    </table>
    <div class="rn-leyenda">CA: Cursando Actualmente &nbsp;|&nbsp; PP: Pr&oacute;rroga de Pago</div>
  </div>

  <ng-template #loading>
    <div class="text-center py-4">
      <i class="fa fa-spinner fa-spin fa-2xl"></i>
      <div>Cargando matriz de notas...</div>
    </div>
  </ng-template>

</div>

<ng-template #modalJustificaciones let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Justificaci&oacute;n de Cambios de Notas</h5>
    <button type="button" class="btn-close" (click)="cancelarJustificaciones()"></button>
  </div>
  <div class="modal-body">
    <p>Indique la justificaci&oacute;n para cada estudiante con notas modificadas:</p>
    <table class="table table-sm">
      <thead class="table-light">
        <tr><th>Carnet</th><th>Nombre</th><th>Nota</th><th>Justificaci&oacute;n</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let j of justificaciones">
          <td>{{ j.M12CAR }}</td>
          <td>{{ j.M12NOM }}</td>
          <td>{{ j.E47NOT }}</td>
          <td><input type="text" class="form-control form-control-sm" [(ngModel)]="j.E47JUS"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelarJustificaciones()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="confirmarJustificaciones()">Formalizar</button>
  </div>
</ng-template>
